import { FormElement } from "./formElements/FormElement";
import { utilities } from "utils/utilities";

export interface Form {
    id: string;
    name: string;
    description: string;
    elements: FormElement[]; // Union type for all form elements
}

export function createForm(
    id: string = utilities.DEFAULT_GUID,
    name: string,
    description: string,
    elements: FormElement[]
): Form {
    return {
        id,
        name,
        description,
        elements,
    };
}